import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUserSettings = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.155 7.95a3.951 3.951 0 1 1-7.902 0 3.951 3.951 0 0 1 7.902 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.6 14.516v.914m0 3.657V20m-2.377-4.114.788.457m3.178 1.828.789.458m-4.755 0 .788-.458m3.178-1.828.789-.457m-1.085.077a1.829 1.829 0 1 1-2.586 2.587 1.829 1.829 0 0 1 2.586-2.587M11.206 14.754c-3.338 0-6.185.504-6.185 2.525s2.831 2.541 6.185 2.541"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUserSettings);
export default ForwardRef;
